  <div>
    <div class="modal-header p-0">
      <div class="p-3">
        <div class="row">
          <div class="col-6">
            <p class="heading-4">
              {{ mls?.languageText?.event_media_list?.key1}}
              <span *ngIf="mls?.is_lskey_display == 1">(event_media_list.key1)</span>
            </p>
          </div>
          <div class="col-6 text-right">
            <span class="cursor-pointer" (click)="goback()">
              <img src="assets/themes/icons/cancel.svg" alt="cross" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <app-media-gallery [mediaData]="mediaList"></app-media-gallery>
    </div>
  </div>